import { NoResults } from "components/organisms";

export const CalendarAvailabilityEmptyState = () => {
  return <NoResults icon="calendarCross" title=" " message="Couldn't find availabilities" />;
};
